import { render, staticRenderFns } from "./ques3.vue?vue&type=template&id=dee94506&scoped=true"
import script from "./ques3.vue?vue&type=script&lang=js"
export * from "./ques3.vue?vue&type=script&lang=js"
import style0 from "./ques3.vue?vue&type=style&index=0&id=dee94506&prod&scoped=true&lang=css"
import style1 from "./ques3.vue?vue&type=style&index=1&id=dee94506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee94506",
  null
  
)

export default component.exports